module.exports = __webpack_public_path__ + "img/pp.afc5c05c.png";